<template>
  <CsOnboardingSurvey
    :user="currentUser"
    :token="token"
    :hutk="hutk"
    :api-base-url="apiBaseUrl"
    :language="currentLocale"
    @set-company="handleSetCompany"
    @success="handleSuccess"
    @error="handleError"
  />
</template>

<script>
import { CsOnboardingSurvey } from "@conecta-suite/vue2-components";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "OnboardingSurvey",
  components: {
    CsOnboardingSurvey,
  },
  computed: {
    ...mapGetters(["token", "currentUser", "company"]),
    hutk() {
      return this.$store.state.hutk;
    },
    apiBaseUrl() {
      return process.env.VUE_APP_API_BASE_URL;
    },
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    ...mapMutations([
      "setCurrentUser",
      "setCompany",
      "setShowLoadingOverlay",
      "setTrialIsAllowed",
    ]),

    async initializeHutk() {
      try {
        await this.$store.dispatch("fetchHutk");
      } catch (error) {
        console.error("Failed to fetch hutk", error);
      }
    },

    handleSetCompany(company) {
      this.setCompany(company);
    },

    async handleSuccess({ response }) {
      this.setShowLoadingOverlay(true);

      this.setCurrentUser(response.user);
      this.setTrialIsAllowed(true);

      try {
        if (!this.company) {
          await this.$router.push({ name: "Install" });
          return;
        }

        await this.$router.push({ name: "Home" });
      } catch (error) {
        console.error("OnboardingSurvey redirect failed", error);
        this.setShowLoadingOverlay(false);
      }
    },

    handleError(error) {
      this.setShowLoadingOverlay(false);
      console.error("CsOnboardingSurvey emitted an error", error);
    },
  },
  created() {
    this.initializeHutk();
  },
};
</script>
